import { TablePagination } from '@mui/material';

interface ReportTablePaginationProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

/**
 * Shared pagination footer for the report tables. Plug the handlers returned by
 * `useSortableTable` straight in.
 */
export function ReportTablePagination({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}: ReportTablePaginationProps) {
  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
    />
  );
}
